// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconListCheck, IconUserPlus, IconFileInfo, IconAlignCenter, IconBoxModel2, IconBoxModel, IconList } from '@tabler/icons';

// constant
const icons = {
    IconListCheck,
    IconUserPlus,
    IconFileInfo,
    IconAlignCenter,
    IconBoxModel2,
    IconBoxModel,
    IconList
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const employeeExpenseGroup = {
    id: 'employee-expense-group',
    type: 'group',
    children: [
        {
            id: 'employee-expense',
            title: <FormattedMessage id="my-expenses" />,
            type: 'collapse',
            breadcrumbs: false,
            icon: icons.IconBoxModel,
            children: [
                {
                    id: 'new-expense',
                    title: <FormattedMessage id="new-expense" />,
                    type: 'item',
                    url: '/expense-form',
                    icon: icons.IconFilePlus,
                    breadcrumbs: false,
                    visible: true
                },
                {
                    id: 'my-expenses',
                    title: <FormattedMessage id="my-expenses" />,
                    type: 'item',
                    url: '/expense-list?type=my_expenses',
                    icon: icons.IconFiles,
                    breadcrumbs: false,
                    visible: true
                },
            ]
        },
    ]
};

export default employeeExpenseGroup;
